import { render, staticRenderFns } from "./CopydataMessage.vue?vue&type=template&id=33ee4a4c"
import script from "./CopydataMessage.vue?vue&type=script&lang=js"
export * from "./CopydataMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports